import mettlAssessmentThumb from "../assets/images/tasks/mettl-assessment-thumb.jpg";
import mettlAssessmentThumbCover from "../assets/images/tasks/mettl-assessment-cover.jpg";
import groupDiscussionsThumb from "../assets/images/tasks/group-discussions-thumb.png";
import groupDiscussionsCover from "../assets/images/tasks/group-discussions-cover.png";
import situationEscalationThumb from "../assets/images/tasks/situation-escalation-thumb.jpg";
import personalInterviewThumb from "../assets/images/tasks/personal-interview-thumb.jpg";
import caseStudiesThumb from "../assets/images/tasks/case-studies-thumb.jpg";
import caseStudiesCover from "../assets/images/tasks/case-studies-cover.jpg";
import personalInterviewCover from "../assets/images/tasks/personal-interview-cover.jpg";
import orientationThumb from "../assets/images/tasks/orientation-thumb.png";
import orientationCover from "../assets/images/tasks/orientation-cover.png";
import rolePlayThumb from "../assets/images/tasks/role-play-thumb.jpg";
import rolePlayCover from "../assets/images/tasks/role-play-cover.png";
import inboxSimulationThumb from "../assets/images/tasks/inbox-simulation-thumb.png";
import inboxSimulationCover from "../assets/images/tasks/inbox-simulation-cover.png";
import surveyCover from "../assets/images/tasks/survey-cover.png";
import surveyThumb from "../assets/images/tasks/survey-thumb.png";
import surveyIcon from "../assets/images/tasks/survey-icon.svg";
import hogan_hpi from "../assets/images/tasks/3-party/hogan/hogan_hpi.jpg";
import hogan_hpi_cover from "../assets/images/tasks/3-party/hogan/hogan_hpi_cover.jpg";
import hogan_hds from "../assets/images/tasks/3-party/hogan/hogan_hds.jpg";
import hogan_hds_cover from "../assets/images/tasks/3-party/hogan/hogan_hds_cover.jpg";
import hogan_mvpi_cover from "../assets/images/tasks/3-party/hogan/hogan_mvpi_cover.jpg";
import hogan_mvpi from "../assets/images/tasks/3-party/hogan/hogan_mvpi.jpg";
import hogan_hbri_cover from "../assets/images/tasks/3-party/hogan/hogan_hbri_cover.jpg";
import hogan_hbri from "../assets/images/tasks/3-party/hogan/hogan_hbri.jpg";
import tte_agile from "../assets/images/tasks/3-party/tte/agile.png";
import tte_agile_cover from "../assets/images/tasks/3-party/tte/agile_cover.jpg";
import ex_cover from "../assets/images/tasks/3-party/tte/ex_cover.jpg";
import ex from "../assets/images/tasks/3-party/tte/ex.png";
import ttei from "../assets/images/tasks/3-party/tte/i.png";
import ttei_cover from "../assets/images/tasks/3-party/tte/I_cover.jpg";
import tter from "../assets/images/tasks/3-party/tte/r.png";
import tter_cover from "../assets/images/tasks/3-party/tte/R_cover.jpg";
import idi from "../assets/images/tasks/3-party/tte/idi.png";
import idi_cover from "../assets/images/tasks/3-party/tte/idi_cover.jpg";
import tdi from "../assets/images/tasks/3-party/tte/tdi.png";
import tdi_cover from "../assets/images/tasks/3-party/tte/tdi_cover.jpg";
import ai_led_session_thumb from '../assets/images/tasks/ai_led_session_card.png'
import ai_led_session_cover from '../assets/images/tasks/ai_led_session_cover.png'


import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";

const imgObj = {
  group_discussion: {
    thumb: groupDiscussionsThumb,
    cover: groupDiscussionsCover,
    value: "group_discussion",
    iconType: regular("screen-users"),
  },
  situation_escalation: {
    thumb: situationEscalationThumb,
    cover: personalInterviewCover,
    value: "situation_escalation",
    iconType: regular("at"),
  },
  interview: {
    thumb: personalInterviewThumb,
    cover: personalInterviewCover,
    value: "interview",
    iconType: regular("user"),
  },
  bta: {
    thumb: personalInterviewThumb,
    cover: personalInterviewCover,
    value: "bta",
    iconType: regular("head-side-gear"),
  },
  case_study: {
    thumb: caseStudiesThumb,
    cover: caseStudiesCover,
    value: "case_study",
    iconType: regular("briefcase"),
  },
  default: {
    thumb: mettlAssessmentThumb,
    cover: mettlAssessmentThumbCover,
    value: "mettl_assessments",
    iconType: regular("grid-2"),
  },
  role_play: {
    thumb: rolePlayThumb,
    cover: rolePlayCover,
    value: "role_play",
    iconType: regular("masks-theater"),
  },
  orientation: {
    thumb: orientationThumb,
    cover: orientationCover,
    value: "orientation",
    iconType: regular("user-group"),
  },
  inbox_simulations: {
    thumb: inboxSimulationThumb,
    cover: inboxSimulationCover,
    value: "inbox_simulation",
    iconType: regular("at"),
  },
  feedback_survey: {
    thumb: surveyThumb,
    cover: surveyCover,
    value: "feedback_survey",
    iconType: surveyIcon,
  },
  hogan_hpi: {
    thumb: hogan_hpi,
    cover: hogan_hpi_cover,
    value: "hogan_assessment",
    iconName: regular("users-gear"),
  },
  hogan_mvpi: {
    thumb: hogan_mvpi,
    cover: hogan_mvpi_cover,
    value: "hogan_assessment",
    iconName: regular("users-gear"),
  },
  hogan_hds: {
    thumb: hogan_hds,
    cover: hogan_hds_cover,
    value: "hogan_assessment",
    iconName: regular("users-gear"),
  },
  hogan_hbri: {
    thumb: hogan_hbri,
    cover: hogan_hbri_cover,
    value: "hogan_assessment",
    iconName: regular("users-gear"),
  },
  tte_agile_interpretify: {
    thumb: ttei,
    cover: ttei_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  tte_agile_reasonify: {
    thumb: tter,
    cover: tter_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  tte_thriving_index: {
    thumb: tdi,
    cover: tdi_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  tte_leadership_derailers_index: {
    thumb: idi,
    cover: idi_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  tte_agile_cognitive_ability: {
    thumb: tte_agile,
    cover: tte_agile_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  tte_element_x: {
    thumb: ex,
    cover: ex_cover,
    value: "TTE_ASSESSMENTS",
    iconName: regular("users-gear"),
  },
  ai_led_session: {
    thumb: ai_led_session_thumb,
    cover: ai_led_session_cover,
    value: "ai_led_session",
    iconName: regular("microchip-ai"),
  }
};

export const taskCatImg = (catName, keyType = "thumb") => {
  if (["thumb", "cover", "iconType"].includes(keyType) && !!catName) {
    if (!imgObj[catName?.toLowerCase()]) return imgObj["default"][keyType];

    return imgObj[catName.toLowerCase()][keyType];
  } else {
    return null;
  }
};
